import React, { useState, useEffect } from "react";
import { useTitle } from "react-use";
import "./styles.css";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getAllHolidayAndAllHolidayPattern
} from "../../../../../actions/holiday";

import { makeStyles } from "@mui/styles";

import DialogUpload from "./DialogUpload";
import DrawerHoliday from "./drawerHoliday";
import AlertResponse from "../../../shared/general/AlertResponse";
import CalendarAndListHoliday from "../../../shared/calendar/calendarAndListHoliday";
import HolidayPatternList from "../../../shared/calendar/holidayPatternList";

const useStyles = makeStyles({
  root: {
    marginTop: "50px",
    marginBottom: "50px",
    "& .MuiTypography-h6": {
      fontSize: "1.5rem",
    },
  }
});

function CalendarComponent() {
  const classes = useStyles();
  const { t } = useTranslation();
  useTitle(`${t("Calendar")} - HR CORE DATA`);
  const dispatch = useDispatch();
  const [openDialogUpload, setOpenDialogUpload] = useState(false);
  const [openDrawerHoliday, setOpenDrawerHoliday] = useState({
    isOpen: false,
  });
  const [alertData, setAlertData] = useState({
    open: false, 
    alertType: null
  });

  const toggleDrawerUpload = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDialogUpload(open);
  };

  useEffect(() => {
    let year = new Date().getFullYear();
    dispatch(getAllHolidayAndAllHolidayPattern(year));
  }, []);

  const handleOpenAlert = ({ alertType }) => {
    setAlertData({
      open: true, 
      alertType: alertType
    });
  };

  const handleCloseAlert = () => {
    setAlertData({
      ...alertData,
      open: false,
    });
  };

  const handleOpenDrawerHoliday = ({ type, holiday }) => {
    setOpenDrawerHoliday({
      isOpen: true,
      type: type,
      data: holiday
    });
  };

  return (
    <div className={classes.root}>
      <CalendarAndListHoliday 
        toggleDrawerUpload={toggleDrawerUpload}
        handleOpenDrawerHoliday={handleOpenDrawerHoliday}
      />
      <HolidayPatternList handleOpenAlert={handleOpenAlert} handleOpenDrawerHoliday={handleOpenDrawerHoliday} />
      <DialogUpload open={openDialogUpload} toggleDrawer={toggleDrawerUpload} handleOpenAlert={handleOpenAlert}/>
      <DrawerHoliday 
        addModal={openDrawerHoliday}
        handleClose={() => {
          setOpenDrawerHoliday({
              isOpen: false,
          });
        }}
        handleOpenAlert={handleOpenAlert}
      />
      <AlertResponse 
        open={alertData.open}
        handleClose={handleCloseAlert}
        alertType={alertData.alertType}
      />
    </div>
  );
}

export default CalendarComponent;
